import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { isAuthed } from "@/lib/auth";
import { isPassengerAuthed } from "@/lib/passengerApi";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import LiveMap from "@/pages/LiveMap";
import NetworkMap from "@/pages/NetworkMap";
import ScheduleDesigner from "@/pages/ScheduleDesigner";
import Schedules from "@/pages/Schedules";
import DispatchBoard from "@/pages/DispatchBoard";
import FleetInventory from "@/pages/FleetInventory";
import PrivateOperators from "@/pages/PrivateOperators";
import EVManagement from "@/pages/EVManagement";
import TicketsRevenue from "@/pages/TicketsRevenue";
import SmartTransitCard from "@/pages/SmartTransitCard";
import Maintenance from "@/pages/Maintenance";
import AlertsIncidents from "@/pages/AlertsIncidents";
import PassManagement from "@/pages/PassManagement";
import Applications from "@/pages/Applications";
import CrewManagement from "@/pages/CrewManagement";
import BusStops from "@/pages/BusStops";
import RouteDesigner from "@/pages/RouteDesigner";
import Reports from "@/pages/Reports";
import OpenDataFeeds from "@/pages/OpenDataFeeds";
import AdminSettings from "@/pages/AdminSettings";
import QRTickets from "@/pages/QRTickets";
import DataManager from "@/pages/DataManager";
import DepotManagement from "@/pages/DepotManagement";
import ServiceAlerts from "@/pages/ServiceAlerts";

// MajheApp Customer Webapp (purple, OTP-authed, no live map for customers)
import MajheLayout from "@/components/majhe/MajheLayout";
import OtpLogin from "@/pages/majhe/OtpLogin";
import MajheHome from "@/pages/majhe/Home";
import BookBus from "@/pages/majhe/BookBus";
import BusResults from "@/pages/majhe/BusResults";
import QuickBook from "@/pages/majhe/QuickBook";
import { MyTickets, TicketView } from "@/pages/majhe/Tickets";
import CardHub from "@/pages/majhe/CardHub";
import PassHub from "@/pages/majhe/PassHub";
import Profile from "@/pages/majhe/Profile";
import MyApplications from "@/pages/majhe/Applications";
import MajheAlerts from "@/pages/majhe/Alerts";

function Protected({ children }) {
  if (!isAuthed()) return <Navigate to="/login" replace />;
  return children;
}

function PassengerProtected({ children }) {
  if (!isPassengerAuthed()) return <Navigate to="/majhe/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Public marketing landing */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />

          {/* MajheApp Customer Webapp - OTP authed, lives at /majhe */}
          <Route path="/majhe/login" element={<OtpLogin />} />
          <Route path="/majhe" element={<PassengerProtected><MajheLayout /></PassengerProtected>}>
            <Route index element={<MajheHome />} />
            <Route path="book" element={<BookBus />} />
            <Route path="book/results" element={<BusResults />} />
            <Route path="book/quick" element={<QuickBook />} />
            <Route path="tickets" element={<MyTickets />} />
            <Route path="tickets/:ticketNo" element={<TicketView />} />
            <Route path="card" element={<CardHub />} />
            <Route path="pass" element={<PassHub />} />
            <Route path="applications" element={<MyApplications />} />
            <Route path="alerts" element={<MajheAlerts />} />
            <Route path="profile" element={<Profile />} />
          </Route>

          {/* Backward-compat redirect: old /citizen paths → /majhe */}
          <Route path="/citizen" element={<Navigate to="/majhe" replace />} />
          <Route path="/citizen/*" element={<Navigate to="/majhe" replace />} />

          {/* Admin protected routes */}
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="live-map" element={<LiveMap />} />
            <Route path="network-map" element={<NetworkMap />} />
            <Route path="schedule" element={<ScheduleDesigner />} />
            <Route path="schedules" element={<Schedules />} />
            <Route path="dispatch" element={<DispatchBoard />} />
            <Route path="fleet" element={<FleetInventory />} />
            <Route path="operators" element={<PrivateOperators />} />
            <Route path="ev" element={<EVManagement />} />
            <Route path="tickets" element={<TicketsRevenue />} />
            <Route path="qr-tickets" element={<QRTickets />} />
            <Route path="transit-cards" element={<SmartTransitCard />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="alerts" element={<AlertsIncidents />} />
            <Route path="passes" element={<PassManagement />} />
            <Route path="applications" element={<Applications />} />
            <Route path="crew" element={<CrewManagement />} />
            <Route path="bus-stops" element={<BusStops />} />
            <Route path="route-designer" element={<RouteDesigner />} />
            <Route path="reports" element={<Reports />} />
            <Route path="open-data" element={<OpenDataFeeds />} />
            <Route path="admin" element={<AdminSettings />} />
            <Route path="users" element={<AdminSettings />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="data-manager" element={<DataManager />} />
            <Route path="depots" element={<DepotManagement />} />
            <Route path="service-alerts" element={<ServiceAlerts />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
